import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DirectEntityFormComponent } from './direct-entity-form/direct-entity-form.component';
import { DirectEntityListComponent } from './direct-entity-list/direct-entity-list.component';

const routes:Routes=[
  {
    path:'',
    data:{
      title:'Direct Entity'
    },
    component:DirectEntityListComponent
  },
  {
    path:'add',
    data:{
      title:'Add Direct Entity'
    },
    component:DirectEntityFormComponent
  },
  {
    path:'edit/:id',
    data:{
      title:'Edit Direct Entity'
    },
    component:DirectEntityFormComponent
  },
  {
    path:'add/:data',
    data:{
      title:'Add Direct Entity'
    },
    component:DirectEntityFormComponent
  },
]

@NgModule({
  imports:[RouterModule.forChild(routes)],
  exports:[RouterModule],
})
export class DirectEntityRoutingModule { }
